// 调整UTC-0时区时间的显示
import { dayjs } from "utils";

export const ohlcvUtcTime = (date: dayjs.Dayjs): dayjs.Dayjs => {
  return date?.utc();
};
